import { routes } from '@/constants/routes/routes';
import userManager from '@/auth';

export default abstract class TollDomainService {
  private static tollEndpoint = `${routes.apiRoutes.basePath}/api/toll-domain/tolldomains`;

  private static datFileEndpoint = `${routes.apiRoutes.basePath}/api/toll-domain/datFiles`;

  private static datEndpoint = `${routes.apiRoutes.basePath}/api/toll-domain/v2/dats`;

  private static activationEndpoint = `${routes.apiRoutes.basePath}/api/toll-domain/zones`;

  static createDat(filedata: any): Promise<Response> {
    const formData = new FormData();
    formData.append('fileDataObu', filedata.fileDataObu);
    formData.append('fileDataDtco', filedata.fileDataDtco);
    formData.append('type', filedata.type);
    formData.append('masterId', filedata.masterId);
    formData.append('fileNameObu', filedata.fileNameObu);
    formData.append('fileNameDtco', filedata.fileNameDtco);
    formData.append('uid', filedata.uid);
    formData.append('name', filedata.name);
    formData.append('signatureObu', filedata.signatureObu);
    formData.append('signatureDtco', filedata.signatureDtco);
    return fetch(this.datEndpoint, {
      method: 'POST',
      headers: {
        Authorization: userManager.getApiKey()
      },
      body: formData
    });
  }

  static createDatVersion(id: number, fileData: any): Promise<Response> {
    const formData = new FormData();
    formData.append('fileDataObu', fileData.fileDataObu);
    formData.append('fileDataDtco', fileData.fileDataDtco);
    formData.append('fileNameObu', fileData.fileNameObu);
    formData.append('fileNameDtco', fileData.fileNameDtco);
    formData.append('validFrom', fileData.validFrom);
    formData.append('signatureObu', fileData.signatureObu);
    formData.append('signatureDtco', fileData.signatureDtco);
    return fetch(`${this.datEndpoint}/${id}/versions`, {
      method: 'POST',
      headers: {
        Authorization: userManager.getApiKey()
      },
      body: formData
    });
  }

  static createRule(rule: string, id: number, contact?: string, countryCode?: string, tspCode?: string): Promise<any> {
    const formData = new FormData();
    formData.append('rule', rule);
    if (contact) {
      formData.append('contact', contact);
    }
    if (countryCode) {
      formData.append('countryCode', countryCode);
    }
    if (tspCode) {
      formData.append('tspCode', tspCode);
    }
    return fetch(`${this.tollEndpoint}/${id}/rule`, {
      method: 'POST',
      headers: {
        Authorization: userManager.getApiKey()
      },
      body: formData
    }).then((response) => {
      if (!response.ok) {
        return response.json().then(text => ({ notificationStatus: 'error', code: response.status, message: text }));
      }
      return {
        notificationStatus: 'success', code: 200
      };
    });
  }

  static updateRule(rule: string, id: number, contact?: string, countryCode?: string, tspCode?: string): Promise<any> {
    const formData = new FormData();
    formData.append('rule', rule);
    if (contact) {
      formData.append('contact', contact);
    }
    if (countryCode) {
      formData.append('countryCode', countryCode);
    }
    if (tspCode) {
      formData.append('tspCode', tspCode);
    }
    return fetch(`${routes.apiRoutes.basePath}/api/toll-domain/rules/${id}`, {
      method: 'PATCH',
      headers: {
        Authorization: userManager.getApiKey()
      },
      body: formData
    }).then((response) => {
      if (!response.ok) {
        return response.json().then(text => ({ notificationStatus: 'error', code: response.status, message: text }));
      }
      return {
        notificationStatus: 'success', code: 200
      };
    });
  }

  static activateGeometry(geometry: any): Promise<any> {
    return fetch(this.activationEndpoint, {
      method: 'PUT',
      headers: {
        'content-type': 'application/json',
        'Authorization': userManager.getApiKey()
      },
      body: JSON.stringify(geometry)
    })
      .then((response) => {
        if (!response.ok) {
          return response.json();
        }
        return response;
      });
  }
}
